import React, { useState } from 'react'
import { hitType_arr, pitch_type_arr, hitTag_arr, buntTag_arr2, hardTag_arr } from '../../../../../item/MyStat/actionList'
import { Space } from '../../../Res/BaseButton'
import { SingleSelect, SingleInput, SinglePointMarker } from '../../../Res/BaseInput'
import { CancelButton, SubmitButton } from '../../../Res/BaseButton'
import { useEffect } from 'react'

export const BallModifyEdit = ({ setIsLoading, initData, handleSaveData, handleCloseBox}) => {
  const [pitchType, setPitchType] = useState(initData.TaggedPitchType)
  const [pitchSpeed, setPitchSpeed] = useState(initData.APP_VeloRel)
  const [hitType, setHitType] = useState(initData.HitType)
  const [hardTag, setHardTag] = useState(initData.HardnessTag)
  const [buntTag, setBuntTag] = useState(initData.BuntTag)
  const [hitTag, setHitTag] = useState(initData.HitTag)
  const [kzoneLoc, setKZoneLoc] = useState([initData.APP_KZoneY, initData.APP_KZoneZ])
  const [loc, setLoc] = useState([initData.LocX, initData.LocY])

  
  useEffect(() => {
    console.log(initData)
    console.log([pitchType, pitchSpeed, hitType, hardTag, buntTag, hitTag, kzoneLoc, loc])
  }, [pitchType, pitchSpeed, hitType, hardTag, buntTag, hitTag, kzoneLoc, loc])

  const saveAll = () => {
    setIsLoading(true)
    let payload = {
      pitch: {
        _id: initData.Pitch_ID,
        type: pitchType,
        APP_VeloRel: parseInt(pitchSpeed) || null,
        APP_KZoneY: parseFloat(kzoneLoc[0]) || null,
        APP_KZoneZ: parseFloat(kzoneLoc[1]) || null,
      },
    }

    if (initData.Inplay_ID) { 
      payload.inplay = {
        _id: initData.Inplay_ID,
        HardTag: hardTag,
        HitTag: hitTag,
        HitType: hitType,
        BuntTag: buntTag,
        LocX: parseFloat(loc[0]) || '',
        LocY: parseFloat(loc[1]) || ''
      }
    }
    console.log(payload)
    handleSaveData(payload, initData.Pitch_ID)
  }
  

  return (
    <>
      <div className='row'>
        <div className='col-sm-12'>
          <SingleSelect title={"球種"}
            val={pitchType}
            attr={pitch_type_arr}
            action={setPitchType}
            hasBlank={true}
            size={3}
          />
          <SingleInput title={"球速"} val={pitchSpeed} action={setPitchSpeed} size={3} />
          <SinglePointMarker title={"進壘座標"} background={"plate"} initPos={kzoneLoc} size={6} setPos={setKZoneLoc} />
        </div>
      </div>
      <Space />
      <br />
      <div className='row'>
        <div className='col-sm-12'>
          <SingleSelect title={"擊球型態"}
            val={hitType}
            attr={hitType_arr}
            action={setHitType}
            hasBlank={true}
            size={3}
          />
          <SingleSelect title={"擊球強度"}
            val={hardTag}
            attr={hardTag_arr}
            action={setHardTag}
            hasBlank={true}
            size={3}
          />
          <SingleSelect title={"觸擊標籤"}
            val={buntTag}
            attr={buntTag_arr2}
            action={setBuntTag}
            hasBlank={true}
            size={3}
          />
        </div>
      </div>
      <Space />
      <br />
      <div className='row'>
        <div className='col-sm-12'>
          <SingleSelect title={"擊球標籤"}
            val={hitTag}
            attr={hitTag_arr}
            action={setHitTag}
            hasBlank={true}
            size={3}
          />
          <SinglePointMarker title={"落點座標"} background={"field"} initPos={loc} size={6} field={initData.Stadium} setPos={setLoc} />
        </div>
      </div>
      <Space />
      <br />
      <div className="row m-t-sm m-t-sm">
            <div className="col-sm-4 col-sm-offset-10">
                <CancelButton name={"關閉"} action={handleCloseBox} />
                <SubmitButton name={"修改"} action={saveAll} />
            </div>
        </div>
    </>
  )
}